import { languages } from './constants';

/**
 * Normalize a locale code to match supported language keys.
 * Falls back to 'en' if no match is found.
 * @param {string} locale - e.g. 'en-GB', 'fr-CA'
 * @returns {string} - normalized language key
 */
export function normalizeLocale(locale) {
  if (!locale) return 'en';

  const supportedKeys = languages.map(lang => lang.key);
  const baseLang = locale.split('-')[0];

  return supportedKeys.includes(baseLang) ? baseLang : 'en';
}
